import { accordionClasses } from '@mui/material';

export default function Accordion() {
  return {
    MuiAccordion: {
      styleOverrides: {
        root: {
          borderBottom: '1px dashed rgba(166, 166, 166, 0.2)',
          '::before': {
            display: 'none'
          },

          [`&.${ accordionClasses.expanded }`]: {
            margin: 0,
          },
        }
      },
    },
  };
}
